(() => {
  if (window.whNavInit) return;
  window.whNavInit = true;

  // Home icon next to the mobile menu button. Placeholder outline house until the final SVG
  // arrives. The header drawer is re-rendered on hydration, so the link is re-inserted
  // whenever it goes missing.
  const HOME_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M3 10.5 12 3l9 7.5"/><path d="M5.5 9V21h4.5v-6h4v6h4.5V9"/></svg>';

  const ensureHome = () => {
    const drawer = document.querySelector('#header-component .header__drawer');
    if (!drawer || drawer.querySelector('.wh-home-icon')) return;
    const link = document.createElement('a');
    link.className = 'header__icon wh-home-icon';
    link.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    link.setAttribute('aria-label', 'Home');
    link.innerHTML = '<span class="svg-wrapper">' + HOME_SVG + '</span>';
    drawer.appendChild(link);
  };

  // Shopify discount links (/discount/CODE) store the code in the discount_code cookie and only
  // apply it in the cart, so the product page would otherwise show full price to people who
  // came from an ad promising the discount. The note sits on the price row (inside product-price,
  // next to the morphed price container) so it adds no height above Add to cart: as a separate
  // line under the price it pushed the button off the first phone screen (Oct 2026).
  // Shown as "<s>$27.95</s> $25.16 Save $2.79" (owner's pick, Oct 2026): the same numbers the cart
  // and checkout show, since Shopify rounds the discount down to the cent (10% of $27.95 = $2.79).
  const OFFERS = { OPENDAY10: 10 };

  const currentCode = () => {
    const match = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    return match ? decodeURIComponent(match[1]).trim().toUpperCase() : '';
  };

  const money = (cents) => '$' + (cents / 100).toFixed(2);

  const ensureNote = () => {
    const percent = OFFERS[currentCode()];
    if (!percent) return;
    const price = document.querySelector('.product-details product-price');
    const box = price && price.querySelector('[ref="priceContainer"]');
    const match = box && box.textContent.match(/([\d,]+\.\d{2})/);
    if (!match) return;
    const cents = Math.round(parseFloat(match[1].replace(/,/g, '')) * 100);
    const off = Math.floor((cents * percent) / 100);
    // The variant picker re-renders the price container, so the strike class is re-applied.
    if (!box.classList.contains('wh-was')) box.classList.add('wh-was');
    let note = price.querySelector('.wh-code-note');
    if (!note) {
      note = document.createElement('span');
      note.className = 'wh-code-note';
      price.appendChild(note);
    }
    // Only write on change: writing is itself a mutation and would re-trigger the observer.
    if (note.dataset.cents === String(cents)) return;
    note.dataset.cents = String(cents);
    const now = document.createElement('span');
    now.className = 'wh-code-note__price';
    now.textContent = money(cents - off);
    const save = document.createElement('span');
    save.className = 'wh-code-note__save';
    save.textContent = 'Save ' + money(off);
    note.replaceChildren(now, save);
  };

  // Product title on phones: long names wrap to 2-3 lines and push the main Add to cart below
  // the first screen (Oct 2026, 390x844: one line 812px, two lines 847px, three lines 882px).
  // Only a title that wraps AND pushes the button off-screen is shrunk, 1px at a time, down to
  // 20px; one-line titles are never touched. Re-measured only when the screen size or the
  // discount note changes, so the observer below does not keep resizing it.
  const MIN_TITLE_PX = 20;
  let fitKey = '';
  const fitTitle = () => {
    if (window.innerWidth >= 750) return;
    const title = document.querySelector('main h1');
    const button = [...document.querySelectorAll('main button[name="add"]')].find((b) => b.offsetParent);
    if (!title || !button) return;
    const key = window.innerWidth + 'x' + window.innerHeight + (document.querySelector('.wh-code-note') ? 'n' : '');
    if (key === fitKey) return;
    fitKey = key;
    title.style.fontSize = '';
    title.style.lineHeight = '';
    const style = getComputedStyle(title);
    const lineHeight = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.1;
    if (title.getBoundingClientRect().height < lineHeight * 1.5) return;
    const limit = window.innerHeight - 8;
    const bottom = () => button.getBoundingClientRect().bottom + window.scrollY;
    let size = parseFloat(style.fontSize);
    while (bottom() > limit && size > MIN_TITLE_PX) {
      size -= 1;
      title.style.fontSize = size + 'px';
      title.style.lineHeight = '1.1';
    }
  };

  // Estimated delivery under Add to cart: 3-8 days, Sundays skipped (printing takes under a day at
  // the provider, 2 days allowed, then 2-5 days Standard US delivery; owner's call, Oct 2026). UPS
  // and USPS deliver on Saturdays: orders #1002 and #1003 both arrived on Saturday Oct 17.
  // Sits below the button, so it never pushes Add to cart down.
  const addDeliveryDays = (from, days) => {
    const date = new Date(from);
    while (days > 0) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0) days -= 1;
    }
    return date;
  };
  const formatDay = (date) => date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const today = new Date();
  const ETA_TEXT = `Order today, get it ${formatDay(addDeliveryDays(today, 3))} – ${formatDay(addDeliveryDays(today, 8))} 🚚`;

  const ensureEta = () => {
    const button = [...document.querySelectorAll('main button[name="add"]')].find((b) => b.offsetParent);
    const form = button && button.closest('product-form-component');
    if (!form) return;
    const next = form.nextElementSibling;
    if (next && next.classList.contains('wh-eta')) return;
    const eta = document.createElement('p');
    eta.className = 'wh-eta';
    eta.textContent = ETA_TEXT;
    form.after(eta);
  };

  const gallery = () => document.querySelector('.media-gallery--carousel slideshow-component');

  // Ads can open the gallery on the photo they show: ?wh_photo=<part of the image file name>.
  // The product's own photo order (and the collection thumbnails) stay as they are.
  // The slideshow only scrolls once it is marked [in-viewport], so wait for that, then check the
  // scroll really moved (select() updates the index even when it cannot scroll yet).
  const showAdPhoto = (tries = 0) => {
    const wanted = new URLSearchParams(location.search).get('wh_photo');
    const slideshow = gallery();
    if (!wanted || tries > 30) return;
    if (!slideshow || !slideshow.slides || !slideshow.hasAttribute('in-viewport')) {
      setTimeout(() => showAdPhoto(tries + 1), 150);
      return;
    }
    const slide = slideshow.slides.find((s) => {
      const img = s.querySelector('img');
      return img && (img.currentSrc || img.src).includes(wanted);
    });
    const scroller = slideshow.querySelector('[ref="scroller"]');
    if (!slide || !scroller || slide === slideshow.slides[0]) return;
    slideshow.select(slideshow.slides.indexOf(slide), undefined, { animate: false });
    setTimeout(() => {
      if (Math.abs(scroller.scrollLeft - slide.offsetLeft) > 10) scroller.scrollTo({ left: slide.offsetLeft, behavior: 'instant' });
    }, 300);
  };

  // One swipe hint per visit on phones: the photos slide left to show the edge of the next one
  // (Clarity, Oct 2026: shoppers rarely discovered the other photos).
  const nudgeGallery = () => {
    if (window.innerWidth >= 750 || new URLSearchParams(location.search).get('wh_photo')) return;
    try {
      if (sessionStorage.getItem('whNudged')) return;
      sessionStorage.setItem('whNudged', '1');
    } catch (error) {
      // Storage blocked: still nudge once for this page view.
    }
    const slideshow = gallery();
    if (!slideshow || !slideshow.slides || slideshow.slides.length < 2) return;
    slideshow.classList.add('wh-nudge');
    setTimeout(() => slideshow.classList.remove('wh-nudge'), 1400);
  };

  // Visitors from a Meta ad get the first-order code even when the ad link has no /discount/ part
  // (catalog ads link straight to the product page). The ad's URL parameters carry utm_source=meta;
  // a same-origin request to /discount/CODE makes Shopify set the discount_code cookie, exactly as
  // opening the discount link would (checked in the cart and at checkout, Oct 2026).
  const AD_CODE = 'OPENDAY10';
  let adCodeAsked = false;
  const applyAdCode = () => {
    if (adCodeAsked || currentCode()) return;
    if (new URLSearchParams(location.search).get('utm_source') !== 'meta') return;
    adCodeAsked = true;
    fetch('/discount/' + AD_CODE, { credentials: 'same-origin', redirect: 'manual' })
      .then(() => run())
      .catch(() => {});
  };

  const run = () => { ensureHome(); ensureNote(); fitTitle(); ensureEta(); applyAdCode(); };

  const init = () => {
    run();
    customElements.whenDefined('slideshow-component').then(() => {
      setTimeout(showAdPhoto, 300);
      setTimeout(nudgeGallery, 1200);
    });
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; run(); });
      setTimeout(() => { if (queued) { queued = false; run(); } }, 150);
    }).observe(document.body, { childList: true, subtree: true });
    // The heading font (Oswald) loads after first paint and changes where the title wraps.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { fitKey = ''; fitTitle(); });
    window.addEventListener('resize', () => fitTitle());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
